import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';


function BookRooms() {
    const navigate = useNavigate();
    useEffect(() => {
        const scriptUrls = [
            '/assets/js/jquery.min.js',
            '/assets/js/bootstrap.bundle.min.js',
            '/assets/js/moment.min.js',
            '/assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
            '/assets/vendor/overlay-scroll/custom-scrollbar.js',
            '/assets/vendor/daterange/daterange.js',
            '/assets/vendor/daterange/custom-daterange.js',
            '/assets/vendor/jquery-ui/jquery-ui.min.js',
            '/assets/vendor/jquery-ui/custom.js',
            '/assets/vendor/datatables/dataTables.min.js',
            '/assets/vendor/datatables/dataTables.bootstrap.min.js',
            '/assets/vendor/datatables/custom/custom-datatables.js',
            '/assets/js/custom.js',


        ];

        let isCancelled = false;

        const loadScriptsSequentially = async () => {
            for (const url of scriptUrls) {
                if (isCancelled) break;

                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = url;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
            }
        };

        loadScriptsSequentially();

        return () => {
            isCancelled = true;
        };
    }, []);
    const handleSubmit = () => {
        // Optional: Add form validation logic here
        navigate("/rooms-allotted");
        setTimeout(() => {
            window.location.reload(); // force page refresh after navigation
        }, 100);
    };
    return (<>
        <div className="app-hero-header d-flex align-items-center">
            {/* Breadcrumb starts */}
            <ol className="breadcrumb">
                <li className="breadcrumb-item">
                    <a href="index-2.html">
                        <i className="ri-home-3-line" />
                    </a>
                </li>
                <li className="breadcrumb-item">Rooms</li>
                <li className="breadcrumb-item text-primary" aria-current="page">
                    Book a Room
                </li>
            </ol>
            {/* Breadcrumb ends */}
            {/* Sales stats starts */}
            <div className="ms-auto d-lg-flex d-none flex-row">
                <div className="input-group">
                    <span className="input-group-text bg-primary-lighten">
                        <i className="ri-calendar-2-line text-primary" />
                    </span>
                    <input type="text" id="abc" className="form-control custom-daterange" />
                </div>
            </div>
            {/* Sales stats ends */}
        </div>

        {/* App body starts */}
        <div className="app-body">
            {/* Row starts */}
            <div className="row gx-4">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title">Book A Room</h5>
                        </div>
                        <div className="card-body">
                            {/* Row starts */}
                            <div className="row gx-4">
                                <div className="col-xxl-3 col-lg-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a1">Patient Name</label>
                                        <input type="text" className="form-control" id="a1" placeholder="Enter fullname" />
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a2">Patient Email</label>
                                        <input type="email" className="form-control" id="a2" placeholder="Enter email address" />
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a3">Gender</label>
                                        <select className="form-select" id="a3">
                                            <option value={0}>Select</option>
                                            <option value={1}>Male</option>
                                            <option value={2}>Female</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a4">Age</label>
                                        <input type="text" className="form-control" id="a4" placeholder="Enter age" />
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a5">Patient Phone</label>
                                        <input type="number" className="form-control" id="a5" placeholder="Enter phone number" />
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a6">Room Type</label>
                                        <select className="form-select" id="a6">
                                            <option value={0}>Select</option>
                                            <option value={1}>Standard</option>
                                            <option value={2}>Deluxe</option>
                                            <option value={3}>Suite</option>
                                            <option value={4}>Private</option>
                                            <option value={4}>Ward</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a7">Room No</label>
                                        <select className="form-select" id="a7">
                                            <option value={0}>Select</option>
                                            <option value={1}>201</option>
                                            <option value={2}>202</option>
                                            <option value={3}>203</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-sm-6">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a8">Admission Date</label>
                                        <input type="date" className="form-control" id="a8" />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="mb-3">
                                        <label className="form-label" htmlFor="a9">Message</label>
                                        <textarea className="form-control" id="a9" placeholder="Enter message" rows={3} defaultValue={""} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="d-flex gap-2 justify-content-end">
                                        <a href="rooms-allotted.html" className="btn btn-outline-secondary">
                                            Cancel
                                        </a>
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={handleSubmit}
                                        >
                                            Book Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* Row ends */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Row ends */}
        </div>
    </>)
}
export default BookRooms;